<!--

Main dashboard for all levels of admin users. Components to edit sections
of the website are loaded based on the privledges of said user.

-->
<template>
  <div>
    <login-box
      :login-status="loggedin"
      @loginComplete="toggleLoginState(true)"
      @logoutComplete="toggleLoginState(false)"></login-box>

    <!-- main area to admin site -->
    <div id="module-wrapper" v-if="loggedin == true">

      <!-- load admin specific. Role is checked on the backend too -->
      <div v-for="mod in adminModules">
        <component :is="mod.name">
        </component>
      </div>

      <!-- load modules to edit based on user -->
      <div v-for="mod in modules">
        <component
          is="load-notes"
          v-bind="{moduleId: mod.id, moduleName: mod.name}">
        </component>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'

//components
import LoginBox from '@/components/layout/LoginBox.vue'
import ManageUser from './ManageUser'
import ManageModule from '@/components/admin/ManageModule.vue'
import RealUpdate from '@/components/admin/RealUpdate.vue'
import LoadNotes from '@/components/admin/LoadNotes.vue'

export default {
  components: {
    LoginBox,
    ManageUser,
    ManageModule,
    RealUpdate,
    LoadNotes
  },
  data () {
    return {
      loggedin: false,
      adminModules: [],
      modules: []
    }
  },
  created: function() {
    
  },
  mounted: function() {
    this.checkStatus()
  },
  methods: {
    checkStatus: function() {
      //verify login or redirect to do so

      //component reference
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: local.$helpers.api() + '/admin/dashboard',
          data: {},
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.loggedin = true
          local.loadModules(response.data)
        })
        .catch(function (error) {
          local.loggedin = false
          console.log("not logged in: ", error)
        });
    },

    loadModules: function(res) {
      //this function loads whatever modules this user is allowed
      //access to. Queries called in each module will verify user again

      //clear anything left from previous logins
      this.clearModules()

      //if user is admin, load everthing
      if (res.role == 1 || res.role == 2) {
        this.loadAdminModules()
      } else if (res.role == 3) {
        this.loadSome()
      } else {
        //something's wrong should never get here
        console.log("invalid user")
      }

    },

    loadAdminModules: function() {
      //need to pass admin modules as an object
      let manageUser = {}
      let manageModule = {}
      let realUpdate = {}

      manageUser.name = "manage-user"
      manageModule.name = "manage-module"
      realUpdate.name = "real-update"

      //top admin only level modules
      this.adminModules.push(manageUser)
      this.adminModules.push(manageModule)
      this.adminModules.push(realUpdate)

      //load all the modules since this is admin
      //this.getAllModules()
    },

    loadSome: function() {
      //load each module. probably need a map[] or whatever

      //component reference
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: local.$helpers.api() + '/admin/module/get',
          data: {},
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //load them modules
          for (var i=0; i<response.data.length; i++) {
            local.modules.push(response.data[i])
          }
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
        });
    },

    getAllModules: function() {
      //component reference
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: local.$helpers.api() + '/admin/module/all',
          data: {},
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //load them modules
          for (var i=0; i<response.data.length; i++) {
            local.modules.push(response.data[i])
          }
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
        });
    },
    getUserModules: function(modules) {

    },

    clearModules: function() {
      this.adminModules = []
      this.modules = []
    },

    toggleLoginState: function(state) {
      if (state == true) {
        this.loggedin = true
        this.checkStatus()
      } else {
        this.loggedin = false
        this.modules = []
        this.checkStatus()
      }
    }
  }
}
</script>

<style>
</style>
